import actions from './actions'

export default function DeficiencysReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_DEFICIENCY:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_DEFICIENCY:
      console.log('EDIT_DEFICIENCY', action)
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
        openModal: action.openModal,
      }
    case actions.RESET_DEFICIENCY:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
        openModal: null,
      }
    case actions.NEW_DEFICIENCY:
      return {
        ...state,
        editing: { deficiencyID: 0 },
        loading: false,
        saveSuccess: false,
        openModal: true,
      }
    case actions.CREATE_DEFICIENCY_RECIEVED ||
      actions.UPDATE_DEFICIENCY_RECIEVED ||
      actions.DELETE_DEFICIENCY_RECIEVED:
      return {
        ...state,
        editing: { deficiencyID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
